import React from 'react'

import { CHART_LEGEND_DEFAULT_COLORS } from '../../consts'
import * as S from './AnalyticsChartLegend.styled'

type AnalyticsChartLegendProps = {
  items: { color?: string; value: string }[]
  showLines?: boolean
}

export const AnalyticsChartLegend = ({ items, showLines = true }: AnalyticsChartLegendProps) => {
  return (
    <S.Container>
      {items.map((item, index) => (
        <S.Item key={index}>
          {showLines && <S.Line color={item.color || CHART_LEGEND_DEFAULT_COLORS[index]} />}
          <S.Text>{item.value}</S.Text>
        </S.Item>
      ))}
    </S.Container>
  )
}
